export default __webpack_public_path__ + "static/video_button_background-0e6068ed92b3f1cd2e6683d61d257857.png";